import {Component, OnInit, AfterViewInit} from '@angular/core';
import {ApiService} from '../api.service';
import {Event as RouterEvent, Router} from '@angular/router';
import {CommonService} from '../common.service';

@Component({
  selector: 'app-loading-component',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})

export class LoadingComponent implements OnInit, AfterViewInit{

  assetsRoute: string = "../../assets";
  constructor(private apiService: ApiService,
              private commonService: CommonService,
              private router: Router) {}

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
  }

  ngAfterViewInit(){
     this.commonService.initPage();
   }

  }



// WEBPACK FOOTER //
// ./src/app/loading/loading.component.ts